import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const SoldProducts = () => {
  const soldData = [
    { name: 'eBay', value: 42, color: '#e53238' },
    { name: 'Shopify', value: 28, color: '#5e8e3e' },
    { name: 'Poshmark', value: 18, color: '#731a3d' },
    { name: 'Vinted', value: 8, color: '#097770' },
    { name: 'Depop', value: 4, color: '#ff6b6b' }
  ];

  const total = soldData.reduce((sum, item) => sum + item.value, 0);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      return (
        <div className="chart-tooltip">
          <p className="tooltip-label">{data.name}</p>
          <p className="tooltip-value">{data.value} sales ({Math.round((data.value / total) * 100)}%)</p>
        </div>
      );
    }
    return null;
  };

  const CustomLegend = ({ payload }) => {
    return (
      <div className="chart-legend">
        {payload.map((entry, index) => (
          <div key={index} className="legend-item">
            <div
              className="legend-color"
              style={{ backgroundColor: entry.color }}
            ></div>
            <span className="legend-name">{entry.value}</span>
            <span className="legend-value">
              {soldData.find(item => item.name === entry.value)?.value}
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="dashboard-card sold-products-card">
      <div className="card-body">
        <div className="card-header">
          <h3 className="card-title">Sold Products</h3>
          <p className="card-subtitle">Sales by platform</p>
        </div>

        <div className="sales-summary">
          <div className="total-sales">
            <span className="sales-number">{total}</span>
            <span className="sales-label">Total Sales</span>
          </div>
        </div>

        <div className="chart-container">
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie
                data={soldData}
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={80}
                dataKey="value"
                animationBegin={0}
                animationDuration={800}
              >
                {soldData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <CustomLegend payload={soldData.map(item => ({ value: item.name, color: item.color }))} />
      </div>
    </div>
  );
};

export default SoldProducts;